import { render, staticRenderFns } from "./ComplaintsList.vue?vue&type=template&id=73d4a86f&scoped=true&"
import script from "./ComplaintsList.vue?vue&type=script&lang=js&"
export * from "./ComplaintsList.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintsList.vue?vue&type=style&index=0&id=73d4a86f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d4a86f",
  null
  
)

export default component.exports